/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1LocationCountriesCountryidLangs202,
  PostApiV1LocationCountriesCountryidLangs400,
  PostApiV1LocationCountriesCountryidLangs401,
  PostApiV1LocationCountriesCountryidLangs404,
  PostApiV1LocationCountriesCountryidLangs500,
  PostApiV1LocationCountriesCountryidLangsMutationRequest,
  PostApiV1LocationCountriesCountryidLangsMutationResponse,
  PostApiV1LocationCountriesCountryidLangsPathParams,
} from "../../types/locationCountryLangController/PostApiV1LocationCountriesCountryidLangs.ts";
import { countryLangViewModelSchema } from "../countryLangViewModelSchema.ts";
import { createCountryLangRequestViewModelSchema } from "../createCountryLangRequestViewModelSchema.ts";

export const postApiV1LocationCountriesCountryidLangsPathParamsSchema =
  z.object({
    countryId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1LocationCountriesCountryidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1LocationCountriesCountryidLangs202Schema = z.lazy(
  () => countryLangViewModelSchema,
) as unknown as ToZod<PostApiV1LocationCountriesCountryidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1LocationCountriesCountryidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountriesCountryidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1LocationCountriesCountryidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountriesCountryidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1LocationCountriesCountryidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountriesCountryidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1LocationCountriesCountryidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCountriesCountryidLangs500>;

export const postApiV1LocationCountriesCountryidLangsMutationRequestSchema =
  z.lazy(
    () => createCountryLangRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1LocationCountriesCountryidLangsMutationRequest>;

export const postApiV1LocationCountriesCountryidLangsMutationResponseSchema =
  z.lazy(
    () => postApiV1LocationCountriesCountryidLangs202Schema,
  ) as unknown as ToZod<PostApiV1LocationCountriesCountryidLangsMutationResponse>;
